import Pusher from 'pusher-js'

/**
 * Cliente WebSocket do unico-reverb (ws-payments.unicopag.com.br).
 *
 * Injeta `$reverb()`, que cria a conexão só na primeira chamada: o socket
 * abre apenas quando uma transação precisa aguardar a confirmação de pagamento.
 */
export default function ({ $config }, inject) {
    if (!$config.REVERB_APP_KEY) {
        return
    }

    let client = null

    inject('reverb', () => {
        if (!client) {
            const port = Number($config.REVERB_PORT)

            client = new Pusher($config.REVERB_APP_KEY, {
                wsHost: $config.REVERB_HOST,
                wsPort: port,
                wssPort: port,
                forceTLS: $config.REVERB_SCHEME === 'https',
                enabledTransports: ['ws', 'wss'],
                // pusher-js exige `cluster`, mas ele é ignorado quando `wsHost` é informado
                cluster: '',
            })
        }

        return client
    })
}
